export default __webpack_public_path__ + "static/SRUS LF035 - Especification Del Producto y Datos Técnicos-7e9a0ce1bcfc7a45bfbd96c83a68ac1a.pdf";